import { useState, useCallback, useEffect } from "react";
import { getContainerClientRegisteredInfo } from "../../../../services/container";
import { parseClientData } from "../../characterizationDetails/utils/clientUtils";
import { resolveClientRegisteredInfoRange } from "../utils/characterizationViewMode";

export const useContainerClientInfo = ({
  container,
  superContainer,
  historyMaterial,
  historyId,
  period,
}) => {
  const [clientInfo, setClientInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadClientInfo = useCallback(async () => {
    const debug =
      process.env.REACT_APP_CHARACTERIZATION2_DEBUG === "true" ||
      process.env.REACT_APP_CHARACTERIZATION2_DEBUG === "1";
    const start = debug ? performance.now() : 0;
    if (!container?._id || !historyMaterial || historyMaterial.length === 0) {
      setClientInfo(null);
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const range = resolveClientRegisteredInfoRange({
        period,
        historyMaterial,
        historyId,
      });
      if (!range) {
        setClientInfo(null);
        setIsLoading(false);
        return;
      }
      const containerId =
        superContainer && superContainer._id !== undefined
          ? superContainer._id
          : container._id;
      const response = await getContainerClientRegisteredInfo(
        range,
        containerId,
      );
      if (response?.data && Object.keys(response.data).length > 0) {
        const clientData = response.data.client
          ? parseClientData(response.data.client)
          : null;
        const registrationClientCode = response.data.client
          ? clientData?.code != null
            ? String(clientData.code)
            : ""
          : "";

        let wasteCategory = null;
        if (response.data.waste_category) {
          try {
            const parsed = JSON.parse(response.data.waste_category);
            wasteCategory = parsed?.wasteCategoryName ? parsed : null;
          } catch {
            wasteCategory = response.data.waste_category;
          }
        }

        const formattedData = {
          registrationClientCode,
          clientParsed: clientData
            ? {
                name: clientData.name || "-",
                code: clientData.code || "-",
                address: clientData.address || "-",
                clientUniqueId: clientData.clientUniqueId || "",
              }
            : {
                name: "-",
                code: "-",
                address: "-",
                clientUniqueId: "",
              },
          weight: response.data.weight || null,
          wasteCategory: wasteCategory
            ? typeof wasteCategory === "object"
              ? wasteCategory
              : { wasteCategoryName: wasteCategory }
            : null,
          clientSource: response.data.clientSource || null,
        };
        setClientInfo(formattedData);
      } else {
        setClientInfo(null);
      }
    } catch (err) {
      console.error("Échec du chargement des informations client:", err);
      setError(err);
      setClientInfo(null);
    } finally {
      setIsLoading(false);
      if (debug) {
        // eslint-disable-next-line no-console
        console.log(
          "[char2] useContainerClientInfo loaded in",
          `${(performance.now() - start).toFixed(0)}ms`,
          {
            containerId:
              superContainer && superContainer._id !== undefined
                ? superContainer._id
                : container?._id,
          },
        );
      }
    }
  }, [container?._id, superContainer, historyMaterial, historyId, period]);

  useEffect(() => {
    if (container?._id && historyMaterial?.length > 0 && true) {
      loadClientInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    container?._id,
    superContainer?._id,
    historyMaterial?.length,
    historyId,
    period?.periodMaterialStartSubfilter,
    period?.periodMaterialStopSubfilter,
    period?.start,
    period?.stop,
  ]);
  return {
    clientInfo,
    isLoading,
    error,
    refetch: loadClientInfo,
  };
};
